
import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';

export default function Applications() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const applications = [
    {
      icon: 'ri-car-line',
      title: 'Rubbers',
      description: 'Used as reinforcing agent in rubber and plastics, and stuffing in the rubber industry',
      image: 'https://readdy.ai/api/search-image?query=rubber%20manufacturing%20industry%2C%20automotive%20tires%2C%20industrial%20rubber%20products%2C%20black%20rubber%20materials%2C%20manufacturing%20facility&width=400&height=250&seq=app-0&orientation=landscape'
    },
    {
      icon: 'ri-brush-line',
      title: 'Ink',
      description: 'Used in concocts white paint for production of printing ink and to dilute printing ink',
      image: 'https://readdy.ai/api/search-image?query=printing%20ink%20manufacturing%2C%20colorful%20inks%2C%20printing%20press%2C%20industrial%20ink%20production%2C%20professional%20printing%20facility&width=400&height=250&seq=app-1&orientation=landscape'
    },
    {
      icon: 'ri-drop-line',
      title: 'Detergents',
      description: 'Acts as a builder and anti-caking agent in detergent formulations',
      image: 'https://readdy.ai/api/search-image?query=detergent%20manufacturing%2C%20cleaning%20products%2C%20soap%20production%2C%20industrial%20cleaning%20chemicals%2C%20white%20powder%20additives&width=400&height=250&seq=app-2&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electric Cables',
      description: 'Provides insulation and flame retardant properties in cable manufacturing',
      image: 'https://readdy.ai/api/search-image?query=electric%20cable%20manufacturing%2C%20industrial%20cables%2C%20wire%20insulation%2C%20electrical%20components%2C%20cable%20production%20line&width=400&height=250&seq=app-3&orientation=landscape'
    },
    {
      icon: 'ri-heart-line',
      title: 'Cosmetics',
      description: 'Used in talcum powders, soap manufacture giving moisture stability, fragrance retention and flow control',
      image: 'https://readdy.ai/api/search-image?query=cosmetics%20manufacturing%2C%20beauty%20products%2C%20skincare%20formulation%2C%20cosmetic%20laboratory%2C%20white%20cosmetic%20powders&width=400&height=250&seq=app-4&orientation=landscape'
    },
    {
      icon: 'ri-basketball-line',
      title: 'Sports',
      description: 'Used as chalk to dry the hands for weightlifting, gymnastics, and rock climbing',
      image: 'https://readdy.ai/api/search-image?query=sports%20equipment%20manufacturing%2C%20athletic%20gear%20production%2C%20sports%20balls%2C%20fitness%20equipment%2C%20industrial%20sports%20facility&width=400&height=250&seq=app-5&orientation=landscape'
    },
    {
      icon: 'ri-palette-line',
      title: 'Paints',
      description: 'Used to make fireproofing and heat preservation products, using in high class glasses',
      image: 'https://readdy.ai/api/search-image?query=paint%20manufacturing%2C%20colorful%20paints%2C%20industrial%20paint%20production%2C%20paint%20mixing%2C%20coating%20materials&width=400&height=250&seq=app-6&orientation=landscape'
    },
    {
      icon: 'ri-file-paper-line',
      title: 'Paper',
      description: 'Improves paper quality and provides opacity in paper manufacturing',
      image: 'https://readdy.ai/api/search-image?query=paper%20manufacturing%20mill%2C%20paper%20production%20line%2C%20white%20paper%20rolls%2C%20industrial%20paper%20facility%2C%20pulp%20processing&width=400&height=250&seq=app-7&orientation=landscape'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Plastics',
      description: 'Enhances, reflect heat-resistant and insulated material, as a smoke suppressant in plastics',
      image: 'https://readdy.ai/api/search-image?query=plastic%20manufacturing%2C%20polymer%20production%2C%20plastic%20pellets%2C%20industrial%20plastic%20facility%2C%20molding%20processes&width=400&height=250&seq=app-8&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'Elastomers',
      description: 'Used as stabilizer in the automotive PVC plastisols and as a matte white coating',
      image: 'https://readdy.ai/api/search-image?query=elastomer%20manufacturing%2C%20flexible%20materials%2C%20industrial%20rubber%20compounds%2C%20polymer%20processing%2C%20synthetic%20materials&width=400&height=250&seq=app-9&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative pt-24 pb-20 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 62, 126, 0.8), rgba(0, 62, 126, 0.6)), url('https://readdy.ai/api/search-image?query=diverse%20industrial%20applications%2C%20multiple%20manufacturing%20industries%2C%20chemical%20processing%2C%20industrial%20facilities%2C%20modern%20manufacturing%20complex%2C%20various%20industrial%20sectors&width=1920&height=600&seq=applications-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-6 text-center text-white">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Applications</h1>
            <p className="text-xl md:text-2xl text-blue-100">
              Versatile Solutions Across Multiple Industries
            </p>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-8">Industrial Applications</h2>
            <p className="text-lg text-gray-600">
              Light Magnesium Carbonate from Shree Govardhan Chemicals is used across diverse industries for its versatility and reliability. Our high-quality MgCO3 serves as an essential component in numerous manufacturing processes, providing superior performance and consistent results.
            </p>
          </div>
        </div>
      </section>

      {/* Applications Grid */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {applications.map((app, index) => (
              <Card key={index} className="overflow-hidden group">
                <div className="relative">
                  <img 
                    src={app.image}
                    alt={app.title}
                    className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center text-blue-600 text-xl">
                    <i className={app.icon}></i>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{app.title}</h3>
                  <p className="text-gray-600 text-sm">{app.description}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Applications */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-800 mb-12 text-center">Key Application Areas</h2>
            
            <div className="space-y-12">
              {/* Cosmetics */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Cosmetics</h3>
                  <p className="text-gray-600 mb-4">
                    Magnesium Carbonate is used in cosmetic application such as talcum powders, soap manufacture giving moisture stability, fragrance retention and flow control. It is also used in toothpaste as a mild abrasive.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Talcum powders
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Soap manufacturing
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Toothpaste formulations
                    </li>
                  </ul>
                </div>
                <div>
                  <img 
                    src="https://readdy.ai/api/search-image?query=cosmetics%20manufacturing%20facility%2C%20beauty%20products%20production%2C%20talcum%20powder%2C%20soap%20manufacturing%2C%20toothpaste%20production%2C%20white%20cosmetic%20powders%2C%20clean%20laboratory%20environment&width=600&height=400&seq=cosmetics-detail&orientation=landscape"
                    alt="Cosmetics Manufacturing"
                    className="rounded-xl shadow-lg object-cover w-full h-80"
                  />
                </div>
              </div>

              {/* Sports */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div className="order-2 lg:order-1">
                  <img 
                    src="https://readdy.ai/api/search-image?query=gym%20chalk%20magnesium%20carbonate%2C%20weightlifting%20chalk%2C%20gymnastics%20chalk%2C%20rock%20climbing%20chalk%2C%20sports%20equipment%2C%20athletic%20training%2C%20fitness%20facility&width=600&height=400&seq=sports-detail&orientation=landscape"
                    alt="Sports Applications"
                    className="rounded-xl shadow-lg object-cover w-full h-80"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Sports</h3>
                  <p className="text-gray-600 mb-4">
                    In the gym, Magnesium Carbonate is used as chalk to dry the hands for weightlifting, gymnastics, and rock climbing.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Weightlifting chalk
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Gymnastics applications
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Rock climbing grip enhancement
                    </li>
                  </ul>
                </div>
              </div>

              {/* Paint, Ink & Paper */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Paint, Ink & Paper</h3>
                  <p className="text-gray-600 mb-4">
                    Magnesium Carbonate used in concocts white paint for production of printing ink and to dilute printing ink. Also it used to make fireproofing and heat preservation products, using in high class glasses, porcelain enamel and ceramic to make the surface brightness.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      White paint production
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Printing ink manufacturing
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Fireproofing products
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      High class glasses and ceramics
                    </li>
                  </ul>
                </div>
                <div>
                  <img 
                    src="https://readdy.ai/api/search-image?query=paint%20and%20ink%20manufacturing%2C%20printing%20ink%20production%2C%20white%20paint%20manufacturing%2C%20fireproofing%20materials%2C%20ceramic%20and%20glass%20production%2C%20industrial%20coating%20facility&width=600&height=400&seq=paint-ink-detail&orientation=landscape"
                    alt="Paint and Ink Manufacturing"
                    className="rounded-xl shadow-lg object-cover w-full h-80"
                  />
                </div>
              </div>

              {/* Plastics, Rubbers and Elastomers */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div className="order-2 lg:order-1">
                  <img 
                    src="https://readdy.ai/api/search-image?query=plastic%20and%20rubber%20manufacturing%2C%20polymer%20production%2C%20PVC%20plastisols%2C%20automotive%20plastics%2C%20industrial%20rubber%20compounds%2C%20elastomer%20processing%2C%20modern%20manufacturing%20equipment&width=600&height=400&seq=plastic-rubber-detail&orientation=landscape"
                    alt="Plastics and Rubber Manufacturing"
                    className="rounded-xl shadow-lg object-cover w-full h-80"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Plastics, Rubbers and Elastomers</h3>
                  <p className="text-gray-600 mb-4">
                    Magnesium Carbonate is used as reinforcing agent in rubber and plastics, and stuffing in the rubber industry. It enhances, reflect heat-resistant and insulated material, as a smoke suppressant in plastics. It is used as stabilizer in the automotive PVC plastisols and as a matte white coating for projection screens.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Reinforcing agent in rubber
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Heat-resistant materials
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Smoke suppressant in plastics
                    </li>
                    <li className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      Automotive PVC plastisols stabilizer
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8">Why Choose Our Light Magnesium Carbonate?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center text-2xl">
                  <i className="ri-award-line"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">Superior Quality</h3>
                <p className="text-blue-100">Consistent high purity and performance across all applications</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center text-2xl">
                  <i className="ri-settings-line"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">Customizable</h3>
                <p className="text-blue-100">Tailored specifications to meet specific application requirements</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center text-2xl">
                  <i className="ri-truck-line"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">Reliable Supply</h3>
                <p className="text-blue-100">Consistent availability and timely delivery across India</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
